var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-dental-row-button.ab069828.png","uri@2x": __webpack_public_path__ + "icon-dental-row-button.3262f89d.png","uri@3x": __webpack_public_path__ + "icon-dental-row-button.b5eff90d.png",
    width: 32,
    height: 32
});